module.exports = __webpack_public_path__ + "img/boy-dosing-sm.56c66473.png";